import { Handshake, Network, Megaphone, TrendingUp, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

// "Why partner with us" — 4 columns inspired by the Rightworks reference,
// rebranded for Vittaniti's partner programme (accounting firms / agencies).
const PARTNER_BENEFITS = [
    {
        icon: Handshake,
        title: "Collaborative solutions",
        body: "By joining forces, we combine your strengths with our offshore depth to deliver comprehensive solutions that address complex client challenges — together.",
    },
    {
        icon: Network,
        title: "Expanded reach",
        body: "Partnering with Vittaniti opens up cross-border growth — tap into our network of SMEs across Europe, the US and India who benefit from your services.",
    },
    {
        icon: Megaphone,
        title: "Co-marketing opportunities",
        body: "We actively collaborate on marketing initiatives, co-create content and promote each other's offerings to amplify reach and increase brand visibility.",
    },
    {
        icon: TrendingUp,
        title: "Lucrative portfolio expansion",
        body: "Expand your solutions portfolio while enhancing revenue streams and strategic value to your customers by reselling Vittaniti's managed services.",
    },
];

export default function WhyPartner() {
    return (
        <section className="section container-page" data-testid="why-partner">
            <div className="max-w-3xl mb-14">
                <p className="overline mb-3 text-brand-amber">Vittaniti partners</p>
                <h2 className="display text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1.05]">
                    Why partner with us?
                </h2>
                <p className="mt-6 text-brand-ink/75 leading-relaxed">
                    We believe in the strength of partnership. Our network spans accounting firms,
                    consultancies and software vendors who share our vision: helping SMEs modernize,
                    scale and operate efficiently — together.
                </p>
                <Link
                    to="/contact?intent=partner"
                    className="btn-primary mt-8 inline-flex"
                    data-testid="why-partner-cta"
                >
                    Become a Partner <ArrowUpRight size={16} />
                </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-border rounded-2xl overflow-hidden border border-brand-border"
                 style={{ boxShadow: "0 14px 30px -22px rgba(20,34,57,0.18)" }}>
                {PARTNER_BENEFITS.map((b, i) => {
                    const Icon = b.icon;
                    return (
                        <article
                            key={b.title}
                            data-testid={`partner-benefit-${i}`}
                            className="bg-white p-8 md:p-9 flex flex-col animate-fade-up"
                            style={{ animationDelay: `${i * 80}ms` }}
                        >
                            <span className="grid place-items-center w-12 h-12 rounded-xl bg-brand-creamLight text-brand-ink mb-6">
                                <Icon size={22} strokeWidth={1.6} />
                            </span>
                            <h3 className="font-serif text-2xl text-brand-ink leading-tight mb-3">{b.title}</h3>
                            <p className="text-sm text-brand-muted leading-relaxed">{b.body}</p>
                        </article>
                    );
                })}
            </div>
        </section>
    );
}
